import type { FC, FormEvent, ReactNode } from 'react'

import { useState } from 'react'

import { Seo, Layout } from '@/components/generals'

const Protected: FC = (): ReactNode => {
    const [failed, setFailed] = useState(false)

    const handleSubmit = (event: FormEvent<HTMLFormElement>): void => {
        event.preventDefault()
        setFailed(true)
    }

    return (
        <Layout>
            <Seo title='Protected Page' />

            <div className='utility-page-wrap'>
                <div className='utility-page-content w-password-page w-form'>
                    <form onSubmit={handleSubmit} className='utility-page-form w-password-page'>
                        <h2 className='white-text'>Protected Page</h2>
                        <div>
                            <label htmlFor='pass' className='hide'>Password</label>
                            <input className='text-field-form w-password-page w-input' autoFocus maxLength={256} name='pass' placeholder='Enter your password' type='password' id='pass' />
                        </div>
                        <input type='submit' className='button w-password-page w-button' value='Submit' />
                        <div className='w-password-page w-form-fail' style={{ display: failed ? 'block' : 'none' }}>
                            <div>Incorrect password. Please try again.</div>
                        </div>
                    </form>
                </div>
            </div>
        </Layout>
    )
}

export default Protected
